import React, { useState } from 'react';

interface SearchTicketModalProps {
    isVisible: boolean;
    onClose: () => void;
    onSearch: (ticketData: any) => void;
    salesreps: any[];
    states: any[];
}

const FilterClientModal: React.FC<SearchTicketModalProps> = ({ isVisible, onClose, onSearch, salesreps, states }) => {
    const [selectedState, setSelectedState] = useState('');
    const [selectedSalesRep, setSelectedSalesRep] = useState('');

    const handleSearchClick = async () => {

        const filters = {
            atc: selectedSalesRep,
            state: selectedState,
        }
        onSearch(filters);
        onClose()
    };

    const handleClearFilters = () => {
        setSelectedState('');
        setSelectedSalesRep('');
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="top">
                    <div className="search">
                        <span className="material-icons-outlined search-icon">search</span>
                        <p className="buscar-header">FILTRAR</p>
                    </div>
                    <div className="close-button" onClick={onClose}>
                        <span className="material-icons-outlined close-icon">close</span>
                    </div>
                </div>
                <div className="body-filter-ticket">
                    <div className="body-filter-dropdown">
                        <select
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            className="dropdown"
                        >
                            <option value="">ESTADO</option>
                            {states?.map((state: any, index) => (
                                <option key={index} value={state.value}>
                                    {state}
                                </option>
                            ))}
                        </select>

                        <select
                            id="salesrep"
                            value={selectedSalesRep}
                            onChange={(e) => setSelectedSalesRep(e.target.value)}
                            className="dropdown"
                        >
                            <option value="">ATC</option>
                            {salesreps?.map((salesrep: any, index) => (
                                <option key={index} value={salesrep.username}>
                                    {salesrep.fullName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="filter-buttons">
                    <button onClick={handleSearchClick} className="filter-search-button">BUSCAR</button>
                    <button onClick={handleClearFilters} className="clear-button">
                        BORRAR FILTROS
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterClientModal;